import { Box, IconButton, styled, Typography } from "@mui/material"
import { extraColors } from "../../../utils/theme"

export const CardRoot = styled(Box)(({ theme }) => ({
  backgroundColor: extraColors.dark10,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2.5),
  marginBottom: theme.spacing(1.5),
}))

export const CardHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginBottom: theme.spacing(1),
}))

export const CardTitle = styled(Typography)({
  flex: 1,
})

export const ActionButton = styled(IconButton)({
  color: extraColors.hint,
})

export const SectionLabel = styled(Typography)(({ theme }) => ({
  color: extraColors.hint,
  marginBottom: theme.spacing(1.5),
  display: "block",
}))

export const RowGroup = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "auto 1fr",
  columnGap: theme.spacing(2),
  rowGap: theme.spacing(1),
  alignItems: "baseline",
}))

const RowRoot = styled(Box)({
  display: "contents",
})

export function Row({
  label,
  value,
}: {
  label: string
  value: React.ReactNode
}) {
  return (
    <RowRoot>
      <Typography variant="small1" sx={{ color: extraColors.hint }}>
        {label}
      </Typography>
      {typeof value === "string" ? (
        <Typography variant="small1" sx={{ color: extraColors.white }}>
          {value}
        </Typography>
      ) : (
        value
      )}
    </RowRoot>
  )
}
